<div class="row">
  <div class="col-md-12 col-lg-4 mb-20" *ngFor="let usefulLinkCard of usefulLinkCards">
    <a [href]="usefulLinkCard.url" [target]="usefulLinkCard.buttonText === 'new' ? '_blank' : ''">
      <div class="image-title-card">
        <div class="card lift">
          <div class="image-tile-container">
            <div class="outer-tile">
              <div class="image-tile show-image" style="background-image: url('{{ usefulLinkCard.headImage }}');"></div>
            </div>
          </div>

          <div class="card-body min-80">
            <i class="{{ usefulLinkCard.headIconClass }}"> </i>
            <h5>{{ usefulLinkCard.title }}</h5>
            <p>{{ usefulLinkCard.body }}</p>
          </div>
        </div>
      </div>
    </a>
  </div>
</div>
